import React from 'react';

const ArrowLink = ({ width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <path
        fill="#909090"
        d="M14.4557971,10.3727273 L7.48661182,10.3727273 C6.07369458,10.3727273 4.92752091,11.5190989 4.92752091,12.9318182 L4.92752091,14.5863636 C4.92752091,15.0005772 4.59173447,15.3363636 4.17752091,15.3363636 C3.76330735,15.3363636 3.42752091,15.0005772 3.42752091,14.5863636 L3.42752091,12.9318182 C3.42752091,10.6907297 5.24520947,8.87272727 7.48661182,8.87272727 L14.4557971,8.87272727 L12.4270363,6.84396645 C12.1341431,6.55107323 12.1341431,6.0761995 12.4270363,5.78330628 C12.7199295,5.49041306 13.1948032,5.49041306 13.4876964,5.78330628 L16.7967874,9.09239719 C17.0896806,9.38529041 17.0896806,9.86016414 16.7967874,10.1530574 L13.4876964,13.4621483 C13.1948032,13.7550415 12.7199295,13.7550415 12.4270363,13.4621483 C12.1341431,13.169255 12.1341431,12.6943813 12.4270363,12.4014881 L14.4557971,10.3727273 Z"
        transform="matrix(1 0 0 -1 0 20.9)"
      />
    </svg>
  );
};

export default ArrowLink;
